
import React from 'react';
import { ImageLibraryContainer } from './ImageLibraryContainer';

interface ImageLibraryProps {
  styleId?: string;
  influenceId?: string;
  backgroundId?: string;
  environmentIds?: string[];
  moodIds?: string[];
  colorIds?: string[];
  imageType?: string | null;
  description?: string;
  debouncedDescription?: string;
  width?: string;
  height?: string;
  selectedImage?: any;
  onImageSelect?: (image: any) => void;
}

const ImageLibrary: React.FC<ImageLibraryProps> = (props) => {
  return <ImageLibraryContainer {...props} />;
};

export default ImageLibrary;
